/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { RestartAodRunRunActionsMutationResponse, RestartAodRunRunActionsPathParams, RestartAodRunRunActions404 } from "../models/RestartAodRunRunActions";

export function getRestartAodRunRunActionsUrl(id: RestartAodRunRunActionsPathParams["id"]) {
  const res = { method: 'PUT', url: `/aod-runs/${id}/restart` as const }
  return res
}

/**
 * @description Resets the run to WAITING, deletes its report, and re-enqueues processing. Allowed from COMPLETED_WITH_EXPORT, COMPLETED_WITHOUT_EXPORT, or FAILED.
 * @summary Restart a run
 * {@link /aod-runs/:id/restart}
 */
export async function restartAodRunRunActions(id: RestartAodRunRunActionsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RestartAodRunRunActionsMutationResponse, ResponseErrorConfig<RestartAodRunRunActions404>, unknown>({ method : "PUT", url : getRestartAodRunRunActionsUrl(id).url.toString(), ... requestConfig })
  return res.data
}